import { Autocomplete, SxProps, TextField } from "@mui/material";
import type { IStore } from "@/api/store";
import React from "react";

export const StoreSelectAutoComplete = ({
    stores,
    value,
    onChange,
    onQueryChange,
    sx,
}: {
    stores: IStore[];
    value: IStore | null;
    onChange: (store: IStore | null) => void;
    onQueryChange: (query: string) => void;
    sx?: SxProps;
}) => {
    const [searchValue, setSearchValue] = React.useState<string>("");

    // Set a debounce so we don't make loads of API calls.
    React.useEffect(() => {
        const handler = setTimeout(() => {
            const trimmed = searchValue.trim();
            if (trimmed.length === 0) {
                return;
            }
            onQueryChange(trimmed);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    return (
        <Autocomplete
            value={value}
            options={stores}
            onChange={(_, store) => onChange(store)}
            getOptionLabel={(opt) => opt.name}
            isOptionEqualToValue={(opt, val) => opt.id === val?.id}
            sx={sx}
            onInputChange={(_, newInputValue) => setSearchValue(newInputValue)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Select a Store"
                    variant="standard"
                />
            )}
        />
    );
};
